import { getListTypes } from '@udecode/plate';
import { getFileViewType } from 'src/utils/get-file-type';

import { FileState } from '../types/file';

/*Used when file details are obtained from formatFileResponse */
export const routeToPrimaryViewURL = ({
  currentFile,
  orgId,
  mode,
}: {
  currentFile: FileState;
  orgId: string;
  mode: string;
}) => {
  const type = currentFile?.primaryFile?.type;
  const view = currentFile?.primaryFile?.view;

  return type && view
    ? `/${mode}/${orgId}/files/${currentFile.id}?view=${
        currentFile?.primaryFile?.id
      }&type=${getFileType({ type, view })}`
    : `/${mode}/${orgId}/files/${currentFile.id}`;
};

export const routeToViewURL = ({
  fileId,
  viewId,
  type,
  view,
  orgId,
  mode,
}: {
  fileId: string;
  viewId: string;
  type: string;
  view: string;
  orgId: string;
  mode: string;
}) => {
  return `/${mode}/${orgId}/files/${fileId}?view=${viewId}&type=${getFileType({ type, view })}`;
};

export const getFileType = ({ type, view }: { type: any; view: any }) => {
  return getFileViewType(type, view);
};
